import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box, FormControlLabel, TextField, } from '@mui/material';
const OpenEnded = ({ isSubmit, setInputValue, inputValue, }) => {
    const handleChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
    };
    return (_jsx(Box, { sx: { ml: '5%' }, children: _jsx(FormControlLabel, { sx: {
                width: '100%',
                border: (theme) => (
                // treat any answer as correct
                inputValue && isSubmit
                    ? `2px solid green`
                    : ''),
                my: 4,
            }, name: "open-ended", label: " ", labelPlacement: "end", "aria-labelledby": "label-open-ended", control: (_jsx(TextField, { sx: {
                    width: '100%',
                }, InputLabelProps: {
                    sx: { color: (t) => (t.portal.global.font.color) },
                }, InputProps: {
                    'aria-describedby': 'label-open-ended',
                    sx: {
                        '& fieldset': {
                            borderColor: (t) => (t.portal.global.font.color),
                        },
                    },
                }, name: "open-ended", placeholder: "Enter your answer", value: inputValue, onChange: handleChange, multiline: true, rows: 6, autoComplete: "off" })) }, "open-ended") }));
};
export default observer(OpenEnded);
//# sourceMappingURL=OpenEnded.js.map